export default function extractObjectFromQuery(fallback = {}) {
  return function(query, param) {
    if(query[param]) {
      return JSON.parse(query[param]);
    }

    return fallback;
  }
}
